import { AllPreference } from '@@types/Preference';

import { NOTIFICATION, NOTIFICATION_RANGE } from '~/constants';
import { PreferenceCategory } from '~/constants/member';
import { append, curry, find, of, path, pipe, propEq, update } from 'ramda';

export const makePreferenceValueFormat = curry((category, value) => {
  return { [category]: value };
});

export const makePreferenceFormat = curry((category, value) => {
  return { category, value: makePreferenceValueFormat(category, value) };
});

export const makePreferencesFormat = curry((category, value) => {
  return of(makePreferenceFormat(category, value));
});

export const getPreferenceByCategory = curry((category: PreferenceCategory, settingList: AllPreference[]) => {
  return find(propEq('category', category), settingList);
});

export const getPreferenceValueByCategory = curry((category: PreferenceCategory, settingList: AllPreference[]) => {
  return pipe(getPreferenceByCategory(category), path(['value', category]))(settingList);
});

export const isNotificationOn = (notification: NOTIFICATION) => {
  return notification === NOTIFICATION.ON;
};

export const isNotificationOff = (notification: NOTIFICATION) => {
  return notification === NOTIFICATION.OFF;
};

export const isNotificationNoneRange = (range) => {
  return range === NOTIFICATION_RANGE.NONE;
};

export const isNotificationAllRange = (range) => {
  return range === NOTIFICATION_RANGE.ALL;
};

export const makeRequestParamsByIndex = curry((index, preference, preferences) => {
  return index === -1 ? append(preference, preferences) : update(index, preference, preferences);
});
